<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>깜짝퀴즈 카테고리 관리</div>
      <!-- Breadcrumb right aligned-->
      <!-- <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">컨텐츠관리</a>
        </li>
        <li class="breadcrumb-item active">개체정보</li>
      </ol> -->
    </div>

    <!-- 상세 -->
    <div class="card card-default">
      <div class="card-header">
        <!-- <select class="custom-select custom-select-sm" @change="categoryChange(cateData.cateValue, type)" v-model="cateData.cateValue" name="srchType" style="width: 98%"> -->
        <select class="custom-select custom-select-sm" @change="categoryChange(categorys.selectValue)" v-model="categorys.selectValue" name="srchType" style="width: 45%">
          <option value="" selected disabled>카테고리를 선택해주세요.</option>
          <option v-for="(option, index) in categorys.options" :value="option.value" :key="index">
            [{{option.value}}] {{ option.text }}
          </option>
        </select>
        <div class="float-right">
          <!-- <b-button @click="popupAddOpen()" class="btn btn-xs btn-outline-info mr-5" variant="outline-primary">카테고리 추가하기</b-button> -->
          <b-button @click="categoryAdd()" class="btn btn-xs btn-outline-info mr-5" variant="outline-primary">카테고리 추가하기</b-button>
        </div>
      </div>
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered" style="background-color: #f7f7f7;">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>code</th>
              <td>
                <span v-show="!categorys.isAddMode">{{categorys.select.code}}</span>
                <select v-show="categorys.isAddMode" class="custom-select custom-select-sm" v-model="categorys.selectValue" name="newCode" style="width: 30%">
                  <option v-for="(option, index) in categorys.options_reserved" :value="option.value" :key="index">
                    {{ option.text }}
                  </option>
                </select>
              </td>
              <th>p_code</th>
              <td>
                <span>{{categorys.select.pcode}}</span>
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                 <!-- <span v-show="!categorys.isAddMode">{{categorys.select.codeNm}}</span>
                 <input v-show="categorys.isAddMode" type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.box')}" v-model="categorys.select.codeNm" placeholder="이름를 입력해주세요." style="width: 100%"/> -->
                 <input type="text" :class="{'form-control':true, 'is-invalid': errors.has('edit.box')}" v-model="categorys.select.codeNm" placeholder="이름를 입력해주세요." style="width: 100%"/>
              </td>
              <th>사용유무</th>
              <td>
                 <!-- <span>{{categorys.select.val2}}</span> -->
                <select class="custom-select custom-select-sm" v-model="categorys.select.val2" name="useYn" style="width: 30%">
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </td>
            </tr>
          </table>
          <br>
          <h4>연결 과목</h4>
          <table class="table table-bordered mt-4">
            <colgroup>
              <col width="10%" class="bg-lightdark"/>
              <col width="40%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr v-for="(subs, index) in [subjectLOW,subjectMID,subjectHIGH]" :key="index">
             <th>{{subs.id == 'LOW' ? '초등' : subs.id == 'MID' ? '중등' : '고등'}}</th>
              <!-- <td colspan="4">
                <b-input-group>
                   <div>
                      <div class="form-check mb-2">
                        <span v-for="(sub, index) in subs.codes" :key="index">
                          <input class="form-check-input ml-2" v-model="subs.codes[index].val2" true-value="Y" false-value="N" type="checkbox"/>
                          <label class="form-check-label ml-4">{{ sub.codeNm }}</label>
                        </span>
                      </div>
                   </div>
                 </b-input-group>
              </td> -->
              <td colspan='3'>
                <Keyword :box="subs.box" :boxText="subs.text" :type="'category'" :id="subs.id" :catePlaceHolder="'과목을 선택해주세요.'" :cateOptions="subs.options" @keywordChange="keywordChange" @keywordRemove="keywordRemove" :key="subs.text"/>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
    <div class="footer">
      <b-button @click="removeCate()" class="btn btn-b btn-dark mr-2" variant="outline-info mr-2">삭제</b-button>
      <div class="float-right">
          <b-button @click="modalClose()" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">닫기</b-button>
          <b-button @click="modalClose('save')" class="btn btn-b btn-info mr-2" variant="info mr-2">저장</b-button>
      </div>
    </div>
    <a id="fileDown" style="display:none;"></a> <!-- 다운로드용 가상 a-->   
    <a id="filePreview" style="display:none;" target="_blank" ></a> <!-- 미리보기용 가상 a-->    
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsCodeList, saveCsCode, deleteCsCode} from "@/api/cs/CsCodeApi";
import {getUsedCategoryList} from "@/api/cs/CsKjquizApi";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject} from "@/utils/Constants";
import Keyword from "../../components/Common/Keyword";
import Axios from 'axios';

export default {
  components: {Keyword},
  props: {
    contSeq: Number,
  },
  setup(props, context) {
    const schOptions = [{value: 'disp_file_nm', text: '파일명'}, {value: 'ext_file_id', text: '파일 아이디'},{value: 'org_file_nm', text: '원본파일명'}]
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const data = reactive(_dataObject) //reactive 반응형 
    data.schOptions = schOptions // 검색 type 선택 

    const categorys = reactive({
      origin : {},      // 선택된 카테고리의 원천 구조체
      select : {},      // 선택된 카테고리의 카피본 구조체: 설정에 의해 값이 변경된다.
      selectValue : '', // 선택된 카테고리 코드
      options : [],     // 카테고리 선택 리스트
      options_reserved : [],     // 추가 가능한 카테고리 선택 리스트
      isAddMode : false,// 카테고리 추가하기 중인지 여부.
    });
    const subjectLOW = reactive({
      id : 'LOW',
      box : [],         // 선택된 과목 이름들
      text : '',        // 선택된 과목 코드들 (separator:',')
      options : [],     // 과목 선택 리스트
      codes : [],       // 과목 code object 리스트
    });
    const subjectMID = reactive({
      id : 'MID',
      box : [],         // 선택된 과목 이름들
      text : '',        // 선택된 과목 코드들 (separator:',')
      options : [],     // 과목 선택 리스트
      codes : [],       // 과목 code object 리스트
    });
    const subjectHIGH = reactive({
      id : 'HIGH',
      box : [],         // 선택된 과목 이름들
      text : '',        // 선택된 과목 코드들 (separator:',')
      options : [],     // 과목 선택 리스트
      codes : [],       // 과목 code object 리스트
    });

    let kjquizCodeList = [];

    const loadCategory = async () => {
      const result = await getCsCodeList({pCode: 'KJ_QUIZ_CATEGORY_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      kjquizCodeList = result.data;
      console.log('kjquiz code list', kjquizCodeList); // test

      const resultLOW = await getCsCodeList({pCode: 'LOW_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      subjectLOW.codes = resultLOW.data || [];

      const resultMID = await getCsCodeList({pCode: 'MID_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      subjectMID.codes = resultMID.data || [];

      const resultHIGH = await getCsCodeList({pCode: 'HIGH_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      subjectHIGH.codes = resultHIGH.data || [];

      const resultKJSUBJECT = await getCsCodeList({pCode: 'KJ_QUIZ_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      if (resultKJSUBJECT.data && resultKJSUBJECT.data.length > 0) {
        resultKJSUBJECT.data.forEach(sub => {
          if (sub.code.startsWith('3280')) subjectLOW.codes.push(sub);
          else if (sub.code.startsWith('3281')) subjectMID.codes.push(sub);
          else if (sub.code.startsWith('3282')) subjectHIGH.codes.push(sub);
        });
      }


      console.log('subject code list LOW', subjectLOW.codes); // test
      console.log('subject code list MID', subjectMID.codes); // test
      console.log('subject code list HIGH', subjectHIGH.codes); // test
      initSubjectCategorys();

    }
    const initSubjectCategorys = (codeObj) => {
      [subjectLOW,subjectMID,subjectHIGH].forEach(subs => {
        initOptions(subs.codes, subs.options);
        subs.box = [];
        subs.text = '';
        subs.codes.forEach(sub => {
          // for checkbox (checkbox는 화면에 표출 안하지만 혹시 사용할지 모르니 남겨둔다.)
          sub.val2 = codeObj && !!codeObj.val1 && codeObj.val1.includes(sub.code) ? 'Y' : 'N';
          // for keyword component dropbox
          if (sub.val2 == 'Y') {
            subs.box.push(sub.codeNm);
            subs.text += subs.text.length > 0 ? ','+sub.code : sub.code;
          }
        });
      });
    }
    const getWithSubjectText = (subjectCodes) => {
      let withSubs = [[],[],[]];
      subjectCodes.forEach(subcode => {
        if (!!subcode) {
          let rv = [subjectLOW,subjectMID,subjectHIGH].some((subs,idx) => { return subs.codes.some(sub => {
            return sub.code == subcode ? (withSubs[idx].push(sub.codeNm), true) : false;
          })});
        }
      });
      return (withSubs[0].length ? ` (초등)${withSubs[0].join('/')}`:``)
            +(withSubs[1].length ? ` (중등)${withSubs[1].join('/')}`:``)
            +(withSubs[2].length ? ` (고등)${withSubs[2].join('/')}`:``);
    }
    const initOptions = (codeList, options) => {
      options.length = 0;
      codeList.forEach(e => {
        let text = e.codeNm;
        if (e.code.startsWith('401')) {
          // 깜짝퀴즈 카테고리인 경우 과목도 표출한다.
          const withSubsText = getWithSubjectText(e.val1.split(','));
          if (!!withSubsText) text += ` : ${withSubsText}`;
        }
        options.push({value: e.code, text});
      });
    }
    const loadData = async (selectValue) => {
      // select init
      categorys.select = {};

      // modal open
      await loadCategory();

      // 현재 코드들 
      initOptions(kjquizCodeList, categorys.options);
      // 추가 가능한 코드들 
      let sCode = 401000;
      categorys.options_reserved.length = 0;
      categorys.options.forEach(opt => {
        for (sCode++; sCode < opt.value; sCode++) {
          categorys.options_reserved.push({value: ''+sCode, text: `${sCode}`});
        }
      });
      for (sCode++; sCode < 402000; sCode++) {
        categorys.options_reserved.push({value: ''+sCode, text: `${sCode}`});
      }
      console.log('options_reserved', categorys.options_reserved.length);

      if (!!selectValue) categoryChange(selectValue);
    }

    const categoryAdd = () =>{
      if (categorys.options_reserved.length > 0) {
        categorys.isAddMode = true;
        categorys.selectValue = categorys.options_reserved[0].value;
        categorys.select = {
          insertMode: true,
          code: categorys.selectValue,
          pCode: 'KJ_QUIZ_CATEGORY_CD',
          pcode: 'KJ_QUIZ_CATEGORY_CD',
          codeNm: '',
          codeDesc: '',
          refCode: '',
          val1: '',
          val2: 'Y',
          orderNum: 1,
          useYn: 'Y',
          // regId: categorys.selectValue,
          // updId: categorys.selectValue,
          printCode: categorys.selectValue,
        };
      }
    }

    const categoryChange = (selectValue) =>{
        categorys.isAddMode = false;
        categorys.origin = kjquizCodeList.find(e => e.code == selectValue) || {};
        categorys.select = _.cloneDeep(categorys.origin);
        initSubjectCategorys(categorys.select);
    }

    const keywordChange = (box,text,type,id) =>{
      if (!!id) {
        [subjectLOW,subjectMID,subjectHIGH].forEach(subs => {
          if (subs.id == id) {
            subs.box = box;
            subs.text = text;
          }
        });
      }
    }

    const keywordRemove = ( box , text , type, id) =>{
      if (!!id) {
        [subjectLOW,subjectMID,subjectHIGH].forEach(subs => {
          if (subs.id == id) {
            subs.box = box;
            subs.text = text;
          }
        });
      }
    }


    const close = () =>{
        context.emit('get-data', {
          contSeq : props.contSeq,
          version : 'info'
      });
    }

    const getUpdatedSubjectList = () => {
      let val1 = '';
      [subjectLOW,subjectMID,subjectHIGH].forEach(subs => {
        if (subs.text.length > 0) {
          val1 += val1.length > 0 ? ','+subs.text : subs.text;
        }
      });
      return val1;
    }
    const checkModified = () => {
      let isModified = false;

      if (categorys.isAddMode) {
        if (!categorys.select || !categorys.select.code) return false;

        categorys.select.codeNm = categorys.select.codeNm.trim();
        if (categorys.select.codeNm.length > 0) {
          isModified = true;
        }

        if (!isModified) {
          alert('이름을 입력해주세요.')
        }
      } else {
        if (!categorys.origin || !categorys.origin.code || categorys.origin.code != categorys.select.code) return false;

        // 연결 과목
        let val1 = getUpdatedSubjectList();
        if (val1 != categorys.origin.val1) isModified = true;

        // 사용 유무 
        if (categorys.select.val2 != categorys.origin.val2) isModified = true;

        // 이름 변경 여부 
        categorys.select.codeNm = categorys.select.codeNm.trim();
        if (categorys.select.codeNm != categorys.origin.codeNm) isModified = true;

        if (categorys.select.codeNm.length == 0) {
          isModified = false;
          alert('이름을 입력해주세요.')
        } else if (!isModified) {
          alert('변경된 내용이 없습니다.')
        }
      }

      return isModified;
    }
    // todo : 사용유무 / 추가하기 / 삭제하기
    const save = async () => {
      let params = {};
      if (categorys.isAddMode) {
        params = categorys.select;
        params.code = categorys.selectValue;
        params.val1 = getUpdatedSubjectList();
      } else {
        params = {
          code: categorys.select.code,
          codeNm: categorys.select.codeNm,
          val1: getUpdatedSubjectList(),
          val2: categorys.select.val2,
        }
      }
      try {
        const result = await saveCsCode(params);
        if (result.data != categorys.select.code) {
          console.log(`저장에 실패했습니다.:${result.data}`);
        } else {
          return true; // success
        }
      } catch (e) {
        console.log(`저장에 실패했습니다.:${e.message}`);
      }
      return false;
    }

    const modalClose = async (type) =>{
        let isModified = false;
        if (type == 'save') {
            if (checkModified()) {
                const isSaved = await save();
                if (isSaved) {
                    alert('저장에 성공했습니다.')
                    loadData(categorys.select.code);
                } else {
                    alert('저장에 실패했습니다.')
                }
            }
        } else {
            context.emit('modal-state','cate');
        }
    }

    const removeCate = async () =>{
        try {
            const resultUsedCate = await getUsedCategoryList();
            const usedCateList = resultUsedCate.data;
            console.log('getUsedCategoryList', usedCateList); // test

            if (!categorys.isAddMode && usedCateList && categorys.select && categorys.select.code) {
                if (!usedCateList.includes(categorys.select.code)) {
                    if (confirm(`정말로 카테고리 코드(${categorys.select.code})를 삭제하시겠습니까?`)) {
                        const result = await deleteCsCode({code: categorys.select.code, ignoreRegId: true});
                        if (result.data.code != categorys.select.code) {
                            console.log(`삭제에 실패했습니다.:${result.data}`);
                            alert('삭제에 실패했습니다.')
                        } else {
                            alert('삭제에 성공했습니다.')
                            loadData();
                        }
                    }
                } else {
                    alert('사용중인 콘텐츠가 있어 삭제할 수 없습니다.')
                }
            } else {
                alert('삭제할 카테고리를 선택해주세요.')
            }
        } catch (e) {
            console.log(`삭제에 실패했습니다. error(${e.message})`);
            alert('삭제에 실패했습니다.')
        }
    }

    onMounted(loadData);
    
    return {
      close,
      data,
      subjectLOW,
      subjectMID,
      subjectHIGH,
      categorys,
      categoryAdd,
      categoryChange,
      keywordChange,
      keywordRemove,
      modalClose,
      removeCate,
      dataAction: new TableActionClass(data),
    }
  },
}

</script>
